import styled, { keyframes } from 'styled-components';

export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  padding: 160px 5% 120px;
  background: #0d1b2a;
  text-align: center;
  color: #ffffff;
`;

export const BackgroundGrid = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px);
  background-size: 60px 60px;
  pointer-events: none;
`;

export const GlowNode = styled.div<{ top?: string; left?: string; right?: string; bottom?: string; color: string }>`
  position: absolute;
  top: ${p => p.top || 'auto'};
  left: ${p => p.left || 'auto'};
  right: ${p => p.right || 'auto'};
  bottom: ${p => p.bottom || 'auto'};
  width: 500px;
  height: 500px;
  border-radius: 50%;
  background: radial-gradient(circle, ${p => p.color} 0%, transparent 70%);
  pointer-events: none;
  z-index: 1;
`;

export const HeroTitle = styled.h1`
  position: relative;
  z-index: 2;
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(2.5rem, 4vw, 3.8rem);
  font-weight: 700;
  margin-bottom: 24px;
  letter-spacing: -0.02em;
`;

export const HeroSubtitle = styled.p`
  position: relative;
  z-index: 2;
  max-width: 680px;
  margin: 0 auto;
  font-size: 1.15rem;
  line-height: 1.7;
  color: #8a99a8;
`;

export const CTAButton = styled.a`
  position: relative;
  z-index: 2;
  display: inline-block;
  background: #ffffff;
  color: #0d1b2a;
  padding: 14px 32px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  border: 1.5px solid #ffffff;
  transition: background 0.2s, color 0.2s, transform 0.15s;
  margin-top: 40px;

  &:hover {
    background: #2dbd96;
    color: #0d1b2a;
    border-color: #2dbd96;
    transform: translateY(-1px);
  }
`;

export const StatsRow = styled.div`
  position: relative;
  z-index: 2;
  margin-top: 70px;
  display: flex;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
  animation: ${fadeUp} 0.9s ease forwards;
`;

export const Stat = styled.div`
  text-align: center;
`;

export const StatNumber = styled.div`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 2.8rem;
  font-weight: 700;
  color: #2dbd96;
`;

export const StatLabel = styled.div`
  margin-top: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8a99a8;
`;
